import React from "react";
import "../RipianiSection.scss";
import { AddIcon }  from "../../../../assets/icons";
import CustomTooltip from "../../../CustomTooltip";

  const RipianiHeader = ({
    edit = false,
    handleAddRipiano,
    ripianiCount,
  }) => {
    return (
      <div className="ripiani-header">
          <p className="ripiani-header-title">Ripiani ({ripianiCount})</p>
        {edit && (
          <CustomTooltip text="Aggiungi ripiano">
            <button className="ripiani-button"  onClick={handleAddRipiano}>
                <AddIcon fillColor="var(--archeo-color)" />
            </button>
          </CustomTooltip>
        )}
      </div>
    );
  };

export default RipianiHeader;
